module.exports = __webpack_public_path__ + "img/xitongshezhi.16395ef7.png";